import React, { useState, useEffect, useRef } from 'react';
import Filter from './bper-filter';
import Button from './bper-button';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import parseHTML from 'html-react-parser';
import MapService from './../utils/MapService';

function SearchBar({
	makeSearchCounter,
	defaultSearchFilter,
	searchFilter,
	translations,
	configurations,
	resultsNumber,
	apiKey,
	apiData,
	place,
	setPlace,
	categories,
	updateSearch,
	goToMyPosition,
	hideDotti,
	zoom,
	bank,
	openFilter,
	setOpenFilter,
	googleMapRef,
	groupId,
	showButtonRepeatSearch,
	searchHere,
	setShowButtonRepeatSearch,
	showSearchValue,
	mapRef,
	currentRegionProvince,
	regions,
	setDefaultMap,
	updateFilter

}) {

	const [showSearchValueAddress, setShowSearchValueAddress] = useState(showSearchValue);
	const placeInputRef = useRef(null);
	const searchBarPlace = place;
	const showCurrentPositionButton = place ? !place.userPosition : false; //mostro solo se non è la posizione corrente in ricerca

	const [addressChangeNotification, setAddressChangeNotification] = useState(undefined);
	const [addressChange, setAddressChange] = useState(true);
	const [addressError, setAddressError] = useState(false);
	const [componentReady, setComponentReady] = useState(false);
	const [addressValue, setAddressValue] = useState((showSearchValue === false) ? "" : undefined);

	useEffect(() => {
		setComponentReady(true);
	}, []);

	useEffect(() => {
		setShowSearchValueAddress(showSearchValue);
	}, [showSearchValue]);


	useEffect(() => {
		if (componentReady && apiData && apiData.mapApi && apiData.mapApi.places) {
			initPlaceAPI();
		}
	}, [componentReady, apiData]);


	const updatePlace = (placeObj) => {

		setPlace(placeObj);
	}

	const moveToMyPosition = () => {
		goToMyPosition();
		/*if (navigator.geolocation) {
			//check if browser support geolocation
			navigator.geolocation.getCurrentPosition(function (position) {
				Geocode.setApiKey(apiKey);
				Geocode.setLanguage('it');
				Geocode.setRegion('it');
				Geocode.fromLatLng(
					position.coords.latitude,
					position.coords.longitude
				).then((response) => {
					setAddressValue(response.results[0].formatted_address);
				});
				//commentato su richiesta di R.T.
			});
		}*/
	};

	const initPlaceAPI = () => {
		setComponentReady(false);
		const autocomplete = new window.google.maps.places.Autocomplete(
			placeInputRef.current,
			{
				types: ['geocode'],
				componentRestrictions: { country: 'it' }
			}
		);
		// Set the data fields to return when the user selects a place.
		autocomplete.setFields(['geometry']);

		new window.google.maps.event.addListener(
			autocomplete,
			'place_changed',
			function () {
				const newPlace = autocomplete.getPlace();
				const address =
					newPlace !== undefined &&
						newPlace.formatted_address !== undefined
						? newPlace.formatted_address
						: placeInputRef.current.value;
				const lat =
					newPlace !== undefined
						? newPlace.geometry !== undefined
							? newPlace.geometry.location.lat()
							: undefined
						: undefined;
				const lng =
					newPlace !== undefined
						? newPlace.geometry !== undefined
							? newPlace.geometry.location.lng()
							: undefined
						: undefined;
				newPlace.geometry
					? setAddressChangeNotification(undefined)
					: setAddressChangeNotification(translations.addressError  /*+ placeInputRef.current.value*/)
				setAddressValue(address);
				setAddressChange(false);


				const placeObj = {
					address: address,
					lat: lat,
					lng: lng,
					userPosition: false
				};
				updatePlace(placeObj);
				setAddressError(false);
			}
		);
	};

	const handleUpdateSearch = (filter, addressChange) => {
		if (addressChange) {
			setAddressChangeNotification(translations.addressError /*+ placeInputRef.current.value*/);
		} else {
			setAddressChangeNotification(undefined);
			setOpenFilter(false);
			updateSearch(filter);
		}
	};

	const onChangeAddress = (event) => {
		setDefaultMap(false);
		setShowSearchValueAddress(true);
		setAddressValue(event.target.value);
		setAddressChange(true);
	};

	const resetAddress = (event) => {
		setAddressValue('');
	};

	const clickDotti = () => {
		hideDotti();
		//setPlace(place);
	};

	const handleSearchHere = (value) => {
		//click sul pulsante SearchHere
		const mapCenter = mapRef?.current?.getCenter();
		const zoom = mapRef?.current?.getZoom();
		if (mapCenter) {
			const center = {
				lat: mapCenter.lat(),
				lng: mapCenter.lng()
			}

			//cerco il "raggio". In pratica la distanza in metri tra il centro della map e il "top" della mappa.
			const mapHeight = googleMapRef.current.clientHeight;
			const metersPerPx = 156543.03392 * Math.cos(center.lat * Math.PI / 180) / Math.pow(2, zoom);
			//Info here: https://stackoverflow.com/questions/5939983/how-does-this-google-maps-zoom-level-calculation-work
			const distance = mapHeight / 2 * metersPerPx;

			searchHere({
				center: center,
				zoom: zoom,
				distance: distance
			});

			setShowButtonRepeatSearch(value);
		}
	}

	const handleOpenFilter = (b) => {
		setOpenFilter(b);
	}

	const showDotti = parseInt(localStorage.getItem("dottiCount")) === 1;

	const [siteKeys, setSiteKeys] = useState({});

	
	return (
		<div className="search-bar-wrapper" onClick={(e) => e.stopPropagation()}>
			{showDotti && (
				<div className="cover cover-2" onClick={() => hideDotti()}></div>
			)}

			{addressChangeNotification &&
				<div className="bper-wrapper">
					<h4 style={{ color: "rgb(0, 99, 105)", marginBottom: "40px" }}>
						{addressChangeNotification}
					</h4>
				</div>
			}

			<div className="search-bar">
				<div className="input-wrapper">
					<input
						type="text"
						className={
							'search-input ' + (addressError ? 'error' : '')
						}
						ref={placeInputRef}
						id="searchinput_indirizzo"
						placeholder={translations.insertAddress}
						onChange={onChangeAddress}
						value={
							showSearchValueAddress
								? addressValue !== undefined
									? addressValue
									: place !== undefined
										? place.address
										: ''

								: ''

						}
					//value={place !== undefined ? place.address : addressValue !== undefined ? addressValue : ''}
					/>
					{addressValue !== undefined ||
						(place !== undefined && place.address !== undefined) ? (
							<div
								className="close-address searchclear input-delete"
								id="clearaddress"
								onClick={resetAddress}
							></div>
						) : (
							<></>
						)}
					<a
						className="search-button"
						onClick={() => handleUpdateSearch(undefined, addressChange)}
					>
						<span></span>
						<span></span>
						<span></span>
					</a>
					<a
						className={
							'filter-button ' + (openFilter ? 'open' : '') + (searchFilter && searchFilter.category ? " active" : "")
						}
						onClick={() => setOpenFilter(!openFilter)}
					>
						<span></span>
						<span></span>
						<span></span>
					</a>
				</div>
				{addressError ? (
					<div className="error-address">
						{translations.notValidField}
					</div>
				) : (
						''
					)}
			</div>
			{categories && (
				<>
					<SlideDown className={'filter-wrapper'} key="slide-down-filter">
						<>
							{openFilter ? (
								<Filter
									makeSearchCounter={makeSearchCounter}
									defaultSearchFilter={defaultSearchFilter}
									initialSearchFilter={searchFilter}
									defaultResultsNumber={resultsNumber}
									translations={translations}
									categories={categories}
									updateSearch={handleUpdateSearch}
									place={place}
									zoom={zoom}
									bank={bank}
									googleMapRef={googleMapRef}
									configurations={configurations}
									groupId={groupId}
									setOpenFilter={handleOpenFilter}
									currentRegionProvince={currentRegionProvince}
									regions={regions}
									updateFilter={updateFilter}
									mapRef={mapRef}
								/>
							) : null}
						</>
					</SlideDown>
				</>
			)}
			{showDotti ? (
				<Button onClick={() => clickDotti()} className="dotti">
					<div className="img-dotti"></div>

					<div className="text">
						<span>
							{translations.dottiMessage &&
								parseHTML(translations.dottiMessage)}
						</span>
					</div>
				</Button>
			) : (
					<div className="current-position-repeat-search">
						{showButtonRepeatSearch &&
							<Button
								variant="contained"
								color="primary"
								className="button-repeat-search" onClick={() => handleSearchHere(false)}>
								{translations.searchRepeat}
							</Button>
						}
						{(showCurrentPositionButton || showButtonRepeatSearch) && (
							<Button
								variant="contained"
								color="primary"
								className="current-position-button"
								onClick={moveToMyPosition}
							>
								<span className="icon-geolocation"></span>
								<span>{translations.actualPosition}</span>
							</Button>
						)}
					</div>
				)}
		</div>
	);
}

export default SearchBar;
